export const DefaultHttpError = 40000;
